import { Component, Input } from '@angular/core';
import { CheckoutOwner } from '@impact/data';

@Component({
    selector: 'app-owner-summary-table',
    template: `
        <div class="unstyled-table unstyled-table--first-child-bold" role="table">
            <div class="unstyled-table__row" role="row">
                <div class="unstyled-table__cell" role="cell">{{ 'user_information.name' | translate }}</div>
                <div class="unstyled-table__cell" role="cell">{{ ownerData?.firstName }} {{ ownerData?.lastName }}</div>
            </div>
            <div class="unstyled-table__row" role="row">
                <div class="unstyled-table__cell" role="cell">{{ 'user_information.phone_number' | translate }}</div>
                <div class="unstyled-table__cell" role="cell">{{ ownerData?.phone }}</div>
            </div>
            <div class="unstyled-table__row" role="row">
                <div class="unstyled-table__cell" role="cell">{{ 'user_information.email' | translate }}</div>
                <div class="unstyled-table__cell" role="cell">{{ ownerData?.email }}</div>
            </div>
            <div class="unstyled-table__row" role="row">
                <div class="unstyled-table__cell" role="cell">{{ 'user_information.address' | translate }}</div>
                <div class="unstyled-table__cell" role="cell">
                    {{ ownerData?.address?.address }}{{ ownerData?.address?.address && ',' }} {{ ownerData?.address?.zipCode }}
                    {{ ownerData?.address?.city }}
                </div>
            </div>
        </div>
    `,
})
export class OwnerSummaryTableComponent {
    @Input() ownerData?: CheckoutOwner;
}
